export default "__VITE_PUBLIC_ASSET__ca850534__"